import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Group = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M19 19h2c0-2.133-.953-5.029-3.553-7.172.721-1.028 1.102-2.216 1.088-3.435-.018-1.535-.673-2.997-1.845-4.116l-1.38 1.446c.79.756 1.214 1.687 1.226 2.693.012 1.042-.43 2.063-1.242 2.877l-.865.864 1.02.676C18.069 14.572 19 17.242 19 19zm-9.5-7c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zM4 20h13v-1c0-3.309-2.691-6-6-6H8c-3.309 0-6 2.691-6 6v1h2z", key: "k0" })));
});
Group.displayName = 'Group';
export var GroupDimensions = { height: 24, width: 24 };
